import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDatatable from "@ashvin27/react-datatable";
import FooterSection from "../components/UI/FooterSection";
import SpanField from "../components/UI/SpanField";
import { Popup } from "../components/UI/Popup";
import { getAllTransfertypedata,updateTransfertype,deleteTransfertype,addTransfertype } from "../config/url.json";
import axios from "axios";
import { CONFIG } from "../config/data";
import AdminSideBar from '../components/container/layout/admin/SideBar';
import AdminHeader from '../components/container/layout/admin/Header';
import LoadingSpinner from "../components/UI/LoadingSpinner";
import InputField from "../components/UI/InputField";
import Validation from "../actions/Validation";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}

function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}

class Transfertype extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableSuccess: {
                message: "",
                status: "",
            },
            records: [],
            actions: "add",
            loading: false,
            showDeleteConfirmPopup: false,
            confirmedDelete: false,
      
             deletePopup: false,
             Transfertype:
             {
               id:"",
               Transfer_type:"",
               
             },
            
             errors: {
                
               
                Transfer_type:"",
               
            },
            formSuccess: {
                message: "",
                status: "",
              },
        };

     
        this.columns = [
            {
                key: "s_no",
                text: "S.no",
                className: "s.no",
                align: "left",
                sortable: true,
            },
         
          /*   {
                key: "id",
                text: "Id",
                className: "id",
                align: "left",
                sortable: true,
            },
           */  {
                key: "Transfer_type",
                text: "Transfer Type",
                className: "Transfer_type",
                align: "left",
                sortable: true,
            },
        
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: (record) => {
                    return (
                        <Fragment>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => this.editRecord(record)}
                                style={{ marginRight: "5px" }}
                            >
                                <i className="fa fa-edit"></i>
                            </button>
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                   this.onDeleteClick(record)
                                }
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </Fragment>
                    );
                },
            },
        ];
        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: false,
                print: false,
            },
        };
    }
   
    handleselectChange = (selectedOptions, e) => {
      let data = this.state.timeoutdata;
      data[e.name] = selectedOptions;
  
      this.setState({ timeoutdata: data });
    };
    clearMessage = () => {
        setTimeout(
            () =>
                this.setState({
                    formSuccess: { message: "" },
                    tableSuccess: { message: "" },
                }),
            5000
        );
    };

   
    componentDidMount = () => {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
            .get(getAllTransfertypedata, null, CONFIG)
            .then((list) => {
                console.log(list)
                let Transfertype = list.data.data;
       
                Transfertype.forEach((element, index) => {
                  let TransferTypeData = {};
                  TransferTypeData.s_no = index + 1;
                  TransferTypeData.id = element.id;
                  TransferTypeData.Transfer_type = element.Transfer_type;
                  Transfertype[index] = TransferTypeData;
                });
        

                this.setState({ records: Transfertype });
            })
            .catch((e) => { console.log(e) });



        
    }
    onDeleteClick(record) {
        this.setState({ addPopup: true, record: record });
      }
    
    cancel = () => {
        let data = this.state.Transfertype;
        data.id="";
        data.Transfer_type = "";
              
        this.setState({ Transfertype: data, actions: "add" });
      };
    editRecord = (record) => {
        console.log(record);
        this.setState({ actions: "edit" });
    
        let  Transfertype = this.state.Transfertype;
        Transfertype.id=record.id;
        Transfertype.Transfer_type = record.Transfer_type;
       
               
        this.handleTransfertypeChange("id",Transfertype.id);
        this.setState({ Transfertype: Transfertype });
      };
    
      clearAll() {
        let actions = this.state.actions;
        actions = "add";
        this.setState({ actions });
        let Transfertype = {};
        Transfertype.id="";
        Transfertype.timeout = "";
        this.setState({ Transfertype });
      }

      handleTransfertypeChange(value, field) {
        let fields = this.state.Transfertype;
        console.log(field);
        if (value === "id") {
          fields.id = field;
             } 
        else if (value === "Transfer_type") {
          fields.Transfer_type = field.target.value;
        
        }  
        this.setState({
            Transfertype: fields,
        });
      }
      updateTransfertype=(e)=> {
        let { Transfertype, errors } = this.state;
        let data = {};
        data.type = "Transfertype";
        data.Transfer_type=Transfertype.Transfer_type;
        errors = Validation(Transfertype, errors);
        this.setState({ errors: errors });
        if (errors.formIsValid) {
          let data = this.state.Transfertype;
    
          if (this.state.actions === "add") {
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${this.props.access_token}`;
      
              axios.post(addTransfertype, data, CONFIG).then((list) => {
                  let res = list.data;
                  if (res.status === "1") {
                      let addstorage = {};
                      addstorage.Transfer_type = data.Transfer_type;
                      addstorage.id = list.data.data[0].id;
                
                      let records = this.state.records;
                      addstorage.s_no = records.length + 1;
                      records.push(addstorage);
                  
                    //  this.setState({ records});
                      toast.success("Transfer type added ",{
                          className:"toast-success"
                        });
                  //    this.setState({ loading: false });
                      this.clearMessage();
                      this.cancel();
            //      }
                      }
              });
          } else {
        
        data.id=Transfertype.id;
        data.Transfer_type = Transfertype.Transfer_type;
        
        axios.put(updateTransfertype, data, CONFIG).then((list) => {
         console.log(data);
         console.log(list.data);
          let response=list.data;
          if (response.status === "1") {

          let member = {};

          member.id=data.id;
          member.Transfer_type = data.Transfer_type;
          
          let records = this.state.records;

          /** Updating the data table */
          let existingRecords = this.state.records;
          var index = existingRecords.findIndex((item) => item.id === data.id);
          existingRecords.splice(index, 1, member);
          this.setState({ records: existingRecords });

          this.setState({ records });
          this.setState({ formSuccess: list.data });
          toast.success("Transfer type updated ",{
            className:"toast-success"
          });
          this.clearAll();
          this.clearMessage();
          this.cancel();
         
          }
        });
      }
    }
      }
      deleteRecord(record) {
        let userId = record.id;
    
        this.setState({ loading: true });
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
          .post(deleteTransfertype, {  id: userId }, CONFIG)
          .then((res) => {
            let response = res.data;
            console.log(response);
            if (response.status === "1") {
              let records = this.state.records;
    
              const deleteIndex = records.map((item) => item.id).indexOf(record.id);
              records.splice(deleteIndex, 1);
              this.setState({ records });
            }
            this.setState({ addPopup: false, record: "", loading: false });
            this.setState({ tableSuccess: res.data });
            toast.error("Transfer type deleted ", {
              className: "toast-error"
            });
       
            this.clearMessage();
          })
          .catch((e) => { });
      }
    
    render() {
        let PopupClose = () => this.setState({ addPopup: false });
        let PopupConfirm = () => this.deleteRecord(this.state.record);
        const {
            Transfertype,
            formSuccess,
            tableSuccess,
            errors,
            loading,
        } = this.state;
        return (
            <div id="layout-wrapper">
                {/* <!-- ============================================================== --> */}
                {/* <!-- Start right Content here --> */}
                {/* <!-- ============================================================== --> */}
                <div className="main-content grayback">
                    <div className="mainpage">
                    <section className="my-head2">
                        <div className="container-fluid">
                            <AdminHeader />
                        </div>
                    </section>
                        <div className="main-box adminMainBox">
                            <div className="sidemenu pr0">
                                <AdminSideBar />
                            </div>


                            <section className="main-body hospital-profilegap checkout-tabs">
                            <div className="container-fluid">
   
                                <div className="col-sm-12">
                                    <h4 className="font-weight-bold mt-3 mb-3">Transfer type for stock report </h4>
                                    <div className="row mt-4">

                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body ">
                                                    <div className="tab-content" id="v-pills-tabContent">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="v-pills-shipping"
                                                            role="tabpanel"
                                                            aria-labelledby="v-pills-shipping-tab"
                                                        >
                                                            <div className="user-notification">
                                                                <SpanField
                                                                    classname={
                                                                        0 === tableSuccess.status
                                                                            ? "text-danger user-notification"
                                                                            : "text-success user-notification"
                                                                    }
                                                                    title={tableSuccess.message}
                                                                />
                                                            </div>
                                                            <ToastContainer position="bottom-center" hideProgressBar={true} autoClose={2000} closeOnClick={false} pauseOnHover />

                                                            <ReactDatatable
                                                                config={this.config}
                                                                records={this.state.records}
                                                                columns={this.columns}
                                                                className="table table-bordered table-striped kas  mobile_table"
                                                            />
                                                                    <Popup
                                        show={this.state.addPopup}
                                        onHide={PopupClose}
                                        onConfirm={PopupConfirm}
                                        title={"Confirmation"}
                                        message={"Are you sure you want to delete this record?"}
                                    />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                            <div className="card">
                            <div class="card-header"> <div class="card-title">   {" "}
                                    {this.state.actions === "Edit"
                                      ? "Edit"
                                      : "Edit"}{" "}
                                    Transfer Type for Stock Report</div> </div>
                              <div className="card-body">
                                <div>
                               
                                  <div className="user-notification">
                                    <SpanField
                                      classname={
                                        0 === formSuccess.status
                                          ? "text-danger user-notification"
                                          : "text-success user-notification"
                                      }
                                      title={formSuccess.message}
                                    />
                                  </div>
                                  <div className="row">
                                 
                               {/*    <div className="col-lg-4">
                                    <div>
                                        <label>ID</label>
                                      </div>
                                      <div className="form-group">
                                       <InputField
                                          inputType={"text"}
                                          name={"id"}
                                          controlFunc={this.handleTransfertypeChange.bind(this,"id")}
                                          content={Transfertype.id}
                                          placeholder={""}
                                          
                                          max={50}
                                        />
                                  
                                      <SpanField
                                        classname="text-danger"
                                        title={errors.id}
                                      /> 
                                   
                                    </div>

                                    <div className="col-lg-4">
                                    
                                      </div>
                                     

                                    </div> */}
                                    <div className="col-lg-4">
                                    <div>
                                        <label>Transfer type</label>
                                      </div>
                                      <div className="form-group">
                                      <InputField
                                          inputType={"text"}
                                          name={"Transfer_type"}
                                          controlFunc={this.handleTransfertypeChange.bind(this,"Transfer_type")}
                                          content={Transfertype.Transfer_type}
                                          placeholder={""}
                                          max={50}
                                        />
                                 
                                      <SpanField
                                        classname="text-danger"
                                        title={errors.Transfer_type}
                                      /> 
                                     
                                    </div>

                                    <div className="col-lg-4">
                                    
                                      </div>
                                     

                                    </div>
                                    <div className="col-lg-4">
                                    <div className='visibleHidden'>
                                        <label>Timeout</label>
                                      </div>
                                    <div className="form-group">
                                      <button
                                          ref="btn"
                                          href="patients-register"
                                          className="signupbtn abtn btdpml btn-margin"
                                          onClick={this.updateTransfertype}>
                                                                                 
                                                                                 {this.state.actions === "add" ? "+ Add" : "Update"}
                                        </button>
                                        <button
                                          href="patients-register"
                                          className="signupbtn abtn btdpml"
                                          onClick={this.cancel}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                      </div>
                                   
                                  </div>
                                </div>
                              </div>
                            </div>
                                        </div>

                                    </div>
                                </div>
                             </div>
                            </section>
                                <FooterSection />
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default connect(
    mapStateToProps,
)(Transfertype);